import { useSearch } from "@sembark-travel/ui/list"
import { ButtonLink, useLocationQuery } from "@sembark-travel/ui/router"
import { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { RolesList } from "./../../../Roles"
import { generatePath } from "./../../../router-utils"

export default function Roles() {
	const [query, setQuery] = useLocationQuery()
	const [params, setParams] = useSearch(query)
	useEffect(() => {
		setQuery(params)
	}, [params, setQuery])
	return (
		<>
			<Helmet>
				<title>Roles</title>
			</Helmet>
			<RolesList
				params={params}
				setParams={setParams}
				actions={
					<ButtonLink
						to={generatePath("/roles/new")}
						level="primary"
						status="primary"
					>
						New Role
					</ButtonLink>
				}
			/>
		</>
	)
}
